
import {
  state,
  getSpreadsheetIdFromUrl,
  removeFromRecentProjectNames,
  removeFromRecentProjectSpreadsheets,
  openIco,
  openSpreadsheet,
  isValidNextcloudUrl,
  openNextcloudUrl,
  recentSpreadsheetProjects,
  recentIcoProjects,
  recentNextcloudProjects,
  removeFromRecentProjects,
  getHrefFromTypeId,
} from "@/store";
import { computed, defineComponent } from "vue";
export default defineComponent({
  setup() {
    const handleOpenIco = async function (value: string) {
      await openIco(value);
      state.fields.projectName = "";
    };
    const handleOpenSpreadsheet = async function (value: string) {
      await openSpreadsheet(value);
      state.fields.spreadsheetUrl = "";
    };
    const handleOpenNextcloudUrl = async function (value: string) {
      await openNextcloudUrl(value);
      state.fields.nextcloudUrl = "";
    };
    const spreadsheetId = computed(() =>
      state.fields.spreadsheetUrl
        ? getSpreadsheetIdFromUrl(state.fields.spreadsheetUrl)
        : ""
    );

    return {
      state,
      isValidNextcloudUrl,
      spreadsheetId,
      openNextcloudUrl,
      removeFromRecentProjectSpreadsheets,
      removeFromRecentProjectNames,
      handleOpenIco,
      handleOpenSpreadsheet,
      handleOpenNextcloudUrl,
      recentSpreadsheetProjects,
      recentNextcloudProjects,
      recentIcoProjects,
      removeFromRecentProjects,
      getHrefFromTypeId,
    };
  },
});
